import { Box, Flex, Heading, Text } from '@chakra-ui/react'
import { PROTECTED_ROUTES } from '@/shared/config/routes'
import { ProtectedPage } from '@/shared/components/ProtectedPage'
import ParentRegistryView from './components/ParentRegistryView'

const ParentRegistry = () => {
    return (
        <ProtectedPage routeConfig={PROTECTED_ROUTES['/user/teacher/parents']}>
            <Box
                h={{ base: 'auto', md: 'calc(100vh - 96px)' }}
                minH={{ base: 'container.sm', md: '520px' }}
                borderRadius={4}
                bg={'white'}
                mx={'auto'}
                py={5}
                px={{ base: 2, md: 17 }}
                display="flex"
                flexDirection="column"
            >
                <Flex my={2} alignItems="center" gap="2" flexWrap="wrap">
                    <Box p="2">
                        <Heading size="md" my={2}>
                            Parent
                        </Heading>
                        <Text color={'gray.600'}>
                            Registry of parents and their children.
                        </Text>
                    </Box>
                </Flex>

                <ParentRegistryView />
            </Box>
        </ProtectedPage>
    )
}

export default ParentRegistry
